import React from "react";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { Modal, ModalBody } from "@material-tailwind/react";
import ModalHeader from "@material-tailwind/react/ModalHeader";

import Loading from "../../../components/loading/Loading";
import { Colors } from "../../../assets/Colors";
import { useQuotationForm } from "./hooks/useQuotationForm";
import QuotationHeader from "./components/QuotationHeader";
import ActivitySelector from "./components/ActivitySelector";
import ActivityDetailTable, {
  renderPortServicesCells,
  renderRentalCells,
  renderWasteCells,
  renderAreaRentalCells,
  renderManpowerCells,
} from "./components/ActivityDetailTable";
import GeneralServiceSection from "./components/GeneralServiceSection";
import SupportingSection from "./components/SupportingSection";

const UOM_CATEGORY = {
  PORT_SERVICES: "1",
  RENTAL: "2",
  WASTE_MANAGEMENT_SERVICES: "3",
  AREA_RENTAL: "4",
};

const QuatationPage = () => {
  const navigate = useNavigate();
  const form = useQuotationForm();

  const {
    data, checkedState, errorLog, ActivityError, showModal, setShowModal,
    firstLoading, secondLoading, rentalSelect, equipmentList, labourList,
    mealOptions, mutationUpdate,
    portServicesIndex, wasteIndex, getActivityIndex,
    quatation, satuan, klien, limbah, waste, room, general, areaRental,
    typeOfClothing, fuel, labour,
    updateData, handleOnChange, handleInsertQuatation, handleSave, handleLoad,
    handleFile, updateActivityDetailRow, handleInsertWSM, deleteWSM,
    handleInsertGM, deleteGM,
    handleInsertEquipment, deleteEquipment, updateEquipmentRow,
    handleInsertLabour, deleteLabour, updateLabourRow,
    handleInsertTws, deleteTws, updateTwsRow,
    handleInsertTruck, deleteTruck, updateTruckRow,
  } = form;

  if (!firstLoading || !secondLoading) return <Loading />;

  return (
    <>
      <div className="md:ml-64">
        {/* Action Bar */}
        <div className="flex w-full justify-between px-4 flex-col sm:flex-row pt-4">
          <button
            onClick={() => navigate("/quotation-or-contract-list")}
            className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
          >
            <BiArrowBack className="text-xl text-gray-800 pr-2" />
            Kembali
          </button>

          <div className="flex w-full justify-end">
            <button
              onClick={handleLoad}
              className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
            >
              Load
            </button>
            <button
              onClick={handleSave}
              className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
            >
              Save
            </button>
            <button
              onClick={handleInsertQuatation}
              className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
            >
              {mutationUpdate.isLoading ? (
                <>
                  <svg aria-hidden="true" role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                  </svg>
                  Loading
                </>
              ) : (
                "Kirim"
              )}
            </button>
          </div>
        </div>

        {/* Header Fields */}
        <QuotationHeader
          data={data}
          errorLog={errorLog}
          klienOptions={klien.minData ?? []}
          updateData={updateData}
        />

        {/* Activity Checkboxes */}
        <ActivitySelector
          activities={quatation.dataBuilder?.Activity}
          checkedState={checkedState}
          ActivityError={ActivityError}
          onToggle={handleOnChange}
        />

        {/* Activity Section Label */}
        <div className="flex flex-wrap -mx-3 px-4 mb-2">
          <div className="w-full px-3">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Activity
            </label>
          </div>
        </div>

        {/* Activity Detail Tables */}
        {data.Activity?.map(({ Name, DetailActivity }, index) => {
          console.log("Rendering activity:", Name, "checked:", checkedState[index], "index:", index);
          
          if (!checkedState[index]) return null;

          if (Name === "GENERAL_SERVICE") {
            console.log("GENERAL_SERVICE is checked, rendering form");
            const generalIdx = getActivityIndex("GENERAL_SERVICE");
            console.log("GENERAL_SERVICE index:", generalIdx);
            console.log("DetailActivity:", DetailActivity);
            return (
              <div key={index} className="px-4 mb-4">
                <div
                  style={{ background: Colors.primary }}
                  className="w-full px-4 border border-gray-500 activity rounded py-3 text-white mb-0"
                >
                  {Name.replace(/[_]/g, " ").toLowerCase()}
                </div>
                <GeneralServiceSection
                  DetailActivity={DetailActivity ?? []}
                  generalIdx={generalIdx}
                  updateActivityDetailRow={updateActivityDetailRow}
                  onInsertGM={handleInsertGM}
                  onDeleteGM={deleteGM}
                  masterData={{
                    room,
                    typeOfClothing,
                    satuan,
                    fuel,
                    general,
                    mealOptions,
                  }}
                />
              </div>
            );
          }

          const uomCategory = UOM_CATEGORY[Name] ?? "1";
          const uomOptions = satuan.minData?.filter(({ CategoryID }) => CategoryID === uomCategory) ?? [];

          const makeUpdateRow = (i, updates) => updateActivityDetailRow(index, i, updates);

          let headers = ["Description"];
          let renderCells;

          switch (Name) {
            case "PORT_SERVICES":
              renderCells = (row, i) =>
                renderPortServicesCells(row, i, { onUpdateRow: (ri, u) => makeUpdateRow(ri, u) });
              break;

            case "RENTAL":
              headers = ["Description", "Detail Unit"];
              renderCells = (row, i) =>
                renderRentalCells(row, i, {
                  onUpdateRow: (ri, u) => makeUpdateRow(ri, u),
                  rentalSelect,
                });
              break;

            case "WASTE_MANAGEMENT_SERVICES":
              headers = ["Description", "Haz. Waste Code", "Waste Description"];
              renderCells = (row, i) =>
                renderWasteCells(row, i, {
                  onUpdateRow: (ri, u) => makeUpdateRow(ri, u),
                  wasteMinData: waste.minData ?? [],
                  limbahMinDataKode: limbah.minDataKode ?? [],
                  limbahMinData: limbah.minData ?? [],
                });
              break;

            case "AREA_RENTAL":
              headers = ["Description", "Kelompok"];
              renderCells = (row, i) =>
                renderAreaRentalCells(row, i, {
                  onUpdateRow: (ri, u) => makeUpdateRow(ri, u),
                  areaRentalMinData: areaRental.minData ?? [],
                });
              break;

            case "MANPOWER":
              renderCells = (row, i) =>
                renderManpowerCells(row, i, {
                  onUpdateRow: (ri, u) => makeUpdateRow(ri, u),
                  labourMinData: labour.minData ?? [],
                });
              break;

            default:
              renderCells = () => null;
          }

          return (
            <div key={index} className="flex flex-wrap -mx-3 px-3 mb-6 px-4">
              <div
                style={{ background: Colors.primary }}
                className="w-full px-4 border border-gray-500 activity rounded py-3 text-white"
              >
                {Name.replace(/[_]/g, " ").toLowerCase()}
              </div>
              <ActivityDetailTable
                rows={DetailActivity ?? []}
                onAdd={() => handleInsertWSM(index)}
                onDelete={(i) => deleteWSM(i, index)}
                headers={headers}
                renderCells={renderCells}
                uomOptions={uomOptions}
                getUomValue={(row) => row.SatuanID}
                onUomChange={(i, value) => updateActivityDetailRow(index, i, { SatuanID: value })}
                getMinUsage={(row) => row.Min_Usage}
                onMinUsageChange={(i, value) => updateActivityDetailRow(index, i, { Min_Usage: value })}
                getRate={(row) => row.Rate}
                onRateChange={(i, value) => updateActivityDetailRow(index, i, { Rate: value })}
              />
            </div>
          );
        })}

        {/* Supporting Tables: TWS, Equipment, Labour, Truck */}
        <SupportingSection
          data={data}
          checkedState={checkedState}
          portServicesIndex={portServicesIndex}
          wasteIndex={wasteIndex}
          masterData={{ satuan, waste, equipmentList, labourList, labour }}
          handlers={{
            handleInsertTws, deleteTws, updateTwsRow,
            handleInsertEquipment, deleteEquipment, updateEquipmentRow,
            handleInsertLabour, deleteLabour, updateLabourRow,
            handleInsertTruck, deleteTruck, updateTruckRow,
          }}
        />

        {/* Load Modal — drag & drop JSON file */}
        <Modal size="md" active={showModal} toggler={() => setShowModal(false)}>
          <ModalHeader toggler={() => setShowModal(false)}>
            Load Data
          </ModalHeader>
          <ModalBody>
            <div
              className="flex justify-center items-center p-10 bg-gray-200 text-gray-700 rounded-lg cursor-pointer"
              onDrop={handleFile}
              onDragOver={(e) => e.preventDefault()}
              onClick={() => document.querySelector('input[type="file"]').click()}
            >
              <p className="text-center">
                Drag and drop file .json di sini atau klik untuk memilih file
              </p>
              <input className="hidden" type="file" onChange={handleFile} />
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default QuatationPage;
